import { theme } from 'antd';

const darkTheme = {
  name: 'dark',
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#22bbe8',
    colorSuccess: '#6dca42',
    colorWarning: '#ff8319',
    colorInfo: '#1668dc',
    colorError: '#ff544e',
    colorLink: '#1668dc',
    colorTextBase: '#ffffff',
    colorBgBase: '#12243b',
    colorBgContainer: '#223348',
    colorBgElevated: '#344559',
    colorBgElevatedDarker: '#12243b',
    colorBgLayout: '#12243b',
    colorBgSpotlight: '#12243b',
    colorBgPanel: '#1b2d43', // Insights panel background
    colorBgPanelContainer: 'rgba(0, 0, 0, 0.08)', // Insights panel container background
    colorPrimaryGrDark: '#1b2d43', // Brand Primary color from Figma
    colorBorder: '#929ba9',
    colorBorderSecondary: '#495769',
    fontFamily: 'Heebo',
    fontFamilyCode: 'Heebo',
    colorText: 'rgba(255, 255, 255, 0.85)',
    colorTextSecondary: 'rgba(255, 255, 255, 0.65)',
    colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
    colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
    colorTextLightSolid: '#ffffff',
    colorTextHeading: 'rgba(255, 255, 255, 0.85)',
    colorTextLabel: 'rgba(255, 255, 255, 0.65)',
    previewOperationColor: 'rgba(255, 255, 255, 0.65)',
    previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
    previewOperationColorBg: 'rgba(0, 0, 0, 0.1)',
    previewTextColor: 'rgba(255, 255, 255, 0.85)',
    previewBackgroundColor: 'rgba(0, 0, 0, 0.75)',
    carouselOutsetArrowColor: 'rgba(255, 255, 255, 0.65)',
    carouselOutsetArrowColorBg: 'rgba(0, 0, 0, 0.1)',
    carouselInsetArrowColor: 'rgba(255, 255, 255, 0.65)',
    carouselInsetArrowColorBg: 'rgba(0, 0, 0, 0.1)',
    colorTextDescription: 'rgba(255, 255, 255, 0.45)',
    colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
    colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
    colorIcon: 'rgba(255, 255, 255, 0.45)',
    colorIconHover: 'rgba(255, 255, 255, 0.85)',
    colorFill: 'rgba(255, 255, 255, 0.18)',
    colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
    colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
    colorFillQuaternary: 'rgba(255, 255, 255, 0.04)',
    colorWhite: '#ffffff',
    colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
    colorBgTextActive: 'rgba(255, 255, 255, 0.18)',
    colorBgTextHover: 'rgba(255, 255, 255, 0.12)',
    colorBorderBg: '#223348',
    colorFillContent: 'rgba(255, 255, 255, 0.12)',
    colorFillContentHover: 'rgba(255, 255, 255, 0.18)',
    colorFillAlter: 'rgba(255, 255, 255, 0.04)',
    transparent: 'rgba(255, 255, 255, 0)',
    colorSplit: 'rgba(255, 255, 255, 0.06)',
    colorErrorBg: '#3a1411',
    colorErrorBgHover: '#451d1d',
    colorErrorBorder: '#5b2725',
    colorErrorBorderHover: '#7e312e',
    colorErrorHover: '#e8766e',
    colorErrorActive: '#ad3e3a',
    colorErrorTextHover: '#e8766e',
    colorErrorText: '#ff675d',
    colorErrorTextActive: '#ad3e3a',
    colorLinkHover: '#1554ad',
    colorInfoBg: '#111a2c',
    colorInfoBgHover: '#112545',
    colorInfoBorder: '#15325b',
    colorInfoBorderHover: '#15417e',
    colorInfoHover: '#1554ad',
    colorInfoActive: '#3c89e8',
    colorInfoTextHover: '#1554ad',
    colorInfoText: '#3c89e8',
    colorInfoTextActive: '#3c89e8',
    colorLinkActive: '#3c89e8',
    colorPrimaryBg: '#143a52',
    colorPrimaryBgHover: '#185a77',
    colorPrimaryBorder: '#1b7a9d',
    colorPrimaryBorderHover: '#1393c2',
    colorPrimaryHover: '#1393c2',
    colorPrimaryActive: '#22bbe8',
    colorPrimaryTextHover: '#78e8ff',
    colorPrimaryText: '#4cd3f5',
    colorPrimaryTextActive: '#22bbe8',
    colorSuccessBg: '#162312',
    colorSuccessBgHover: '#1d3712',
    colorSuccessBorder: '#274916',
    colorSuccessBorderHover: '#306317',
    colorSuccessHover: '#3c8618',
    colorSuccessActive: '#3c8618',
    colorSuccessTextHover: '#6abe39',
    colorSuccessText: '#49aa19',
    colorSuccessTextActive: '#3c8618',
    colorWarningBg: '#2c1c11',
    colorWarningBgHover: '#452812',
    colorWarningBorder: '#5b3516',
    colorWarningBorderHover: '#e0701a',
    colorWarningHover: '#e0701a',
    colorWarningActive: '#ad5c17',
    colorWarningTextHover: '#e8933d',
    colorWarningText: '#ff8319',
    colorWarningTextActive: '#ad5c17',
    colorErrorOutline: 'rgba(255, 84, 78, 0.11)',
    colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
    controlItemBgActive: '#143a52',
    controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.18)',
    controlItemBgActiveHover: '#185a77',
    controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
    controlOutline: 'rgba(0, 60, 180, 0.15)',
    controlTmpOutline: 'rgba(255, 255, 255, 0.04)',
    colorFillAlterSolid: '#1d1d1d',
    fontWeightNormal: 400,
    imageTagFontSizeSM: 14.4,
    imageTagFontSize: 16,
    imagePreviewToolbarFontSize: 20,
    colorFilledHandleBg: '#303030',
    colorBgSolid: 'rgba(255, 255, 255, 0.95)',
    colorBgSolidActive: 'rgba(255, 255, 255, 0.9)',
    colorBgSolidHover: '#ffffff',
    solidTextColor: '#000000',
    colorMagenta: '#cb2b83',
    colorMagentaBg: '#291321',
    colorMagentaBgHover: '#40162f',
    colorMagentaBorder: '#551c3b',
    colorMagentaBorderHover: '#75204f',
    colorMagentaHover: '#a02669',
    colorMagentaActive: '#f37fb7',
    colorMagentaTextHover: '#a02669',
    colorMagentaText: '#f37fb7',
    colorMagentaTextActive: '#f8a8cc',
    colorYellow: '#d8bd14',
    colorYellowBg: '#2b2611',
    colorYellowBgHover: '#443b11',
    colorYellowBorder: '#595014',
    colorYellowBorderHover: '#7c6e14',
    colorYellowHover: '#aa9514',
    colorYellowActive: '#f3ea62',
    colorYellowTextHover: '#e8d639',
    colorYellowText: '#d8bd14',
    colorYellowTextActive: '#aa9514',
    colorCyan: '#13a8a8',
    colorCyanBg: '#112123',
    colorCyanBgHover: '#113536',
    colorCyanBorder: '#144848',
    colorCyanBorderHover: '#146262',
    colorCyanHover: '#138585',
    colorCyanActive: '#58d1c9',
    colorCyanTextHover: '#33bcb7',
    colorCyanText: '#58d1c9',
    colorCyanTextActive: '#33bcb7',
    colorGeekBlue: '#2b4acb',
    colorGeekBlueBg: '#131629',
    colorGeekBlueBgHover: '#161d40',
    colorGeekBlueBorder: '#1c2755',
    colorGeekBlueBorderHover: '#203175',
    colorGeekBlueHover: '#263ea0',
    colorGeekBlueActive: '#5273e0',
    colorGeekBlueTextHover: '#5273e0',
    colorGeekBlueText: '#7f9ef3',
    colorGeekBlueTextActive: '#5273e0',
    colorLime: '#8bbb11',
    colorLimeBg: '#1f2611',
    colorLimeBgHover: '#2e3c10',
    colorLimeBorder: '#3e4f13',
    colorLimeBorderHover: '#536d13',
    colorLimeHover: '#6f9412',
    colorLimeActive: '#c9e75d',
    colorLimeTextHover: '#a9d134',
    colorLimeText: '#8bbb11',
    colorLimeTextActive: '#a9d134',
    colorPurple: '#642ab5',
    colorPurpleBg: '#1a1325',
    colorPurpleBgHover: '#24163a',
    colorPurpleBorder: '#301c4d',
    colorPurpleBorderHover: '#3e2069',
    colorPurpleHover: '#51258f',
    colorPurpleActive: '#ab7ae0',
    colorPurpleTextHover: '#854eca',
    colorPurpleText: '#ab7ae0',
    colorPurpleTextActive: '#854eca',
    colorGold: '#d89614',
    colorGoldBg: '#2b2111',
    colorGoldBgHover: '#443111',
    colorGoldBorder: '#594214',
    colorGoldBorderHover: '#7c5914',
    colorGoldHover: '#aa7714',
    colorGoldActive: '#e8b339',
    colorGoldTextHover: '#aa7714',
    colorGoldText: '#d89614',
    colorGoldTextActive: '#e8b339',
    colorVolcano: '#d84a1b',
    colorVolcanoBg: '#2b1611',
    colorVolcanoBgHover: '#441d12',
    colorVolcanoBorder: '#592716',
    colorVolcanoBorderHover: '#7c3118',
    colorVolcanoHover: '#aa3e19',
    colorVolcanoActive: '#e87040',
    colorVolcanoTextHover: '#aa3e19',
    colorVolcanoText: '#d84a1b',
    colorVolcanoTextActive: '#e87040',
    colorIR: '#e0251b',
    colorIRBg: '#240d0b',
    colorIRoBgHover: '#3a1411',
    colorIRBorder: '#571e19',
    colorIRBorderHover: '#752620',
    colorIRHover: '#a03028',
    colorIRActive: '#f04437',
    colorIRTextHover: '#a03028',
    colorIRText: '#ff675d',
    colorIRTextActive: '#f04437',
    colorAzure: '#4cd3f5',
    colorAzureBg: '#143a52',
    colorAzureBgHover: '#185a77',
    colorAzureBorder: '#1b7a9d',
    colorAzureBorderHover: '#1393c2',
    colorAzureHover: '#1393c2',
    colorAzureActive: '#1393c2',
    colorAzureTextHover: '#1393c2',
    colorAzureText: '#4cd3f5',
    colorAzureTextActive: '#1393c2',
    onePxSize: 1,
    CompairAssure: {
      colorPrimary: '#ffffff',
      colorSecondary: '#0E2954',
    },
    GDPlatinumColor: '#ffffff',
    Ecoplant_Compressor: {
      headerHeight: 58,
      headerBg: '#223348',
      headerFontSize: 16,
      headerFontSizeSM: 14,
      fontHeight: 22,
      fontSize: 14,
      lineHeight: 1.5714285714285714,
      lineWidth: 1,
      fontFamily: 'Heebo',
      fontWeightStrong: 600,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 32,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineHeightLG: 1.5,
      borderRadiusLG: 8,
      colorTextHeading: 'rgba(255, 255, 255, 0.85)',
      colorTextDescription: 'rgba(255, 255, 255, 0.45)',
      colorText: 'rgba(255, 255, 255, 0.85)',
      colorPrimary: '#22bbe8',
      colorFillAlter: 'rgba(255, 255, 255, 0.04)',
      colorBorderSecondary: '#495769',
      colorBgContainer: '#223348',
      fontWeight: 400,
      colorStatusbar: '#223348',
      colorBGMaintenance: '#2c1c11',
      colorBGStopped: '#3a1411',
      colorBGPackagecare: '#ad3e3a',
      'colorBGmissing spec': '#143a52',
      colorBGSelected: '#143a52',
    },
    Ecoplant_Charts: {
      dotSize: 12,
      indicatorHeightSM: 14,
      textFontSizeXXL: 38,
      textFontSizeSM: 18,
      colorWarning: '#ff8319',
      colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
      colorTextLightSolid: '#ffffff',
      colorText: 'rgba(255, 255, 255, 0.85)',
      colorSuccess: '#6dca42',
      colorPrimary: '#22bbe8',
      colorErrorHover: '#e8766e',
      colorError: '#ff544e',
      colorInlineBorder: '#495769',
      colorBgContainer: '#223348',
      fontFamily: 'Heebo',
      textFontSizeXL: 24,
      textFontSizeLG: 16,
      colorBorder: '#929ba9',
      colorBgElevated: '#344559',
      colorBgElevatedDarker: '#12243b',
      colorEnergyDay: '#2b4acb',
      colorEnergyMonth: '#138585',
      colorEnergyYear: '#1554ad',
      colorWarningLight: '#e0701a',
      colorActualenergy: '#138585',
      colorBaseline: '#2b4acb',
      colorSpecificPowerValue: '#1554ad',
      colorOldProductionfloor: '#22bbe8',
      colorOldProductionfloorWaist: '#1b7a9d',
      colorOldProductionfloorProduction: '#1393c2',
      colorNewProductionfloor: '#33bcb7',
      colorNewProductionfloorWaist: '#13a8a8',
      colorNewProductionfloorProduction: '#138585',
      colorSystemProductionfloor: '#5273e0',
      colorSystemProductionfloorWaist: '#2b4acb',
      colorSystemProductionfloorProduction: '#263ea0',
      colorInsightsRisk: '#ff544e',
      colorInsightsEnergy: '#52c41a',
      colorInsightsMaintenance: '#ff8319',
      colorLinechart_1: '#3c89e8',
      colorLinechart_2: '#d89614',
      colorLinechart_3: '#ab7ae0',
      colorLinechart_4: '#8bbb11',
      colorLinechart_5: '#d84a1b',
      colorLinechart_6: '#4cd3f5',
      colorLinechart_7: '#d8bd14',
      colorLinechart_8: '#f37fb7',
      colorLinechart_9: '#58d1c9',
      colorLinechart_10: '#7f9ef3',
      colorChartsLines: 'rgba(255, 255, 255, 0.06)',
    },
  },
  components: {
    Menu: {
      activeBarBorderWidth: 0,
      itemBg: '#344559',
      colorPrimary: '#22bbe8',
      itemSelectedColor: 'rgba(255, 255, 255, 0.85)',
    },
    Button: {
      colorBgContainerDisabled: 'rgb(34,51,72)',
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      primaryColor: 'rgba(0,0,0,0.88)',
      colorLink: '#22bbe8',
      colorLinkHover: '#4cd3f5',
      colorLinkActive: '#4cd3f5',
    },
    Skeleton: {
      paragraphLiHeight: 40,
    },
    Drawer: {
      padding: 0,
      paddingLG: 0,
      paddingXS: 0,
    },
    Tabs: {
      horizontalItemPadding: '12px 12px',
    },
    Card: {
      colorBgContainer: '#344559',
      colorBorderSecondary: '#929ba9',
      bodyPadding: 16,
      headerPadding: 16,
    },
    Collapse: {
      headerBg: '#344559',
      contentBg: '#344559',
      contentPadding: 4,
    },
    Tag: {
      defaultBg: 'rgba(255, 255, 255, 0.04)',
    },
  },
};

export default darkTheme;
